import React, { useState, useEffect } from "react";
import { deleteSinglePosts, getAllPosts } from "../../../../api/ApiConfig";
import "../approvereject/hr.css";
import toast from "react-hot-toast";
import { FaRegFolderOpen } from "react-icons/fa";

const DeletePosts = () => {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedPost, setSelectedPost] = useState(null);
  const [rejectRemark, setRejectRemark] = useState("");
  const [showRemarkBox, setShowRemarkBox] = useState(false);
  const [mediaIndex, setMediaIndex] = useState(0);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [pagination, setPagination] = useState({
    page: 1,
    page_size: 5,
    has_next: false,
    total_pages: 1,
    total_items: 0,
  });

  useEffect(() => {
    const fetchPendingPosts = async () => {
      try {
        setLoading(true);
        const response = await getAllPosts({
          page: pagination.page,
          page_size: pagination.page_size,
        });

        if (response.status === "success") {
          const transformedData = response.data.items.map((item, index) => ({
            slno: index + 1,
            uploadedBy: item.emp_name,
            employeeId: item.emp_id,
            postType: item.posts_type,
            dateTime: new Date(item.created_on).toLocaleDateString(),
            remarks: "",
            media: item.posts_attachments, // array of objects
            description: item.posts_contents,
            originalData: item,
          }));

          setRequests(transformedData);
          setPagination({
            page: response.data.page,
            page_size: response.data.page_size,
            has_next: response.data.has_next,
            total_pages: response.data.total_pages,
            total_items: response.data.total_items,
          });
        } else {
          setError(response.message || "Failed to fetch pending posts");
        }
      } catch (err) {
        setError(err.message || "An error occurred while fetching data");
      } finally {
        setLoading(false);
      }
    };

    fetchPendingPosts();
  }, [pagination.page, pagination.page_size]);

  const handleView = (request) => {
    setSelectedPost(request);
    setRejectRemark("");
    setShowRemarkBox(false);
    setMediaIndex(0);
  };

  const handleClose = () => {
    setSelectedPost(null);
    setRejectRemark("");
    setShowRemarkBox(false);
    setShowDeleteConfirmation(false);
  };

  const handleDeleteClick = () => {
    setShowDeleteConfirmation(true);
  };

  const handleDeleteConfirm = async () => {
    try {
      if (!selectedPost) return;

      const postId = selectedPost.originalData.posts_id;
      const response = await deleteSinglePosts({ posts_id: postId });

      if (response.status === "success") {
        toast.success("Post deleted successfully!");
        const refreshedResponse = await getAllPosts({
          page: pagination.page,
          page_size: pagination.page_size,
        });

        if (refreshedResponse.status === "success") {
          const transformedData = refreshedResponse.data.items.map(
            (item, index) => ({
              slno: index + 1,
              uploadedBy: item.emp_name,
              employeeId: item.emp_id,
              postType: item.posts_type,
              dateTime: new Date(item.created_on).toLocaleDateString(),
              remarks: "",
              media: item.posts_attachments,
              description: item.posts_contents,
              originalData: item,
            })
          );

          setRequests(transformedData);
          setPagination({
            page: refreshedResponse.data.page,
            page_size: refreshedResponse.data.page_size,
            has_next: refreshedResponse.data.has_next,
            total_pages: refreshedResponse.data.total_pages,
            total_items: refreshedResponse.data.total_items,
          });
        }
        handleClose();
      } else {
        alert(`Deletion failed: ${response.message}`);
      }
    } catch (error) {
      alert(`Error Deleting post: ${error.message}`);
    }
  };

  const handleDeleteCancel = () => {
    setShowDeleteConfirmation(false);
  };

  const goNext = () => {
    if (selectedPost) {
      setMediaIndex((prev) =>
        prev + 1 < selectedPost.media.length ? prev + 1 : 0
      );
    }
  };

  const goPrev = () => {
    if (selectedPost) {
      setMediaIndex((prev) =>
        prev - 1 >= 0 ? prev - 1 : selectedPost.media.length - 1
      );
    }
  };

  const handleNextPage = () => {
    if (pagination.has_next) {
      setPagination((prev) => ({
        ...prev,
        page: prev.page + 1,
      }));
    }
  };

  const handlePrevPage = () => {
    if (pagination.page > 1) {
      setPagination((prev) => ({
        ...prev,
        page: prev.page - 1,
      }));
    }
  };

  if (loading) return <div className="container">Loading...</div>;
  if (error) return <div className="container">Error: {error}</div>;

  return (
    <div className="container">
      <h3 className="center">Delete Posts</h3>
      {requests.length === 0 ? (
        <div className="no-posts">
          <div className="no-posts-icon">
            <FaRegFolderOpen />
          </div>
          <p>No Posts Available</p>
        </div>
      ) : (
        <>
          <table className="request-table">
            <thead>
              <tr>
                <th>Slno</th>
                <th>Uploaded by</th>
                <th>Employee ID</th>
                <th>Post type</th>
                <th>Posted on</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {requests.map((req, idx) => (
                <tr key={idx}>
                  <td>{req.slno}</td>
                  <td>{req.uploadedBy}</td>
                  <td>{req.employeeId}</td>
                  <td>{req.postType}</td>
                  <td>{req.dateTime}</td>
                  <td>
                    <button
                      className="view-btn"
                      onClick={() => handleView(req)}
                    >
                      View
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="pagination">
            <button
              onClick={handlePrevPage}
              disabled={pagination.page === 1}
              className="view-btn"
            >
              Prev
            </button>
            <p className="page-info">
              Page {pagination.page} of {pagination.total_pages}
            </p>
            <button
              onClick={handleNextPage}
              disabled={!pagination.has_next}
              className="view-btn"
            >
              Next
            </button>
          </div>

          {selectedPost && (
            <div className="modal-overlay mt-5">
              <div className="modal-content">
                <span className="modal-close-icon" onClick={handleClose}>
                  &times;
                </span>
                <h5 className="modal-heading">Post Details</h5>

                {Array.isArray(selectedPost.media) &&
                  selectedPost.media.length > 0 && (
                    <div className="media-container">
                      <button className="nav-button left" onClick={goPrev}>
                        ❮
                      </button>
                      <div className="media-box">
                        {(() => {
                          const mediaItem = selectedPost.media[mediaIndex];
                          const mediaUrl =
                            mediaItem?.content || mediaItem?.content || "";

                          if (typeof mediaUrl !== "string") return null;

                          return mediaUrl.includes(".mp4") ? (
                            <video controls className="media">
                              <source src={mediaUrl} type="video/mp4" />
                            </video>
                          ) : (
                            <img
                              src={mediaUrl}
                              alt="Post Media"
                              className="media"
                            />
                          );
                        })()}
                        <span className="media-count">
                          {mediaIndex + 1}/{selectedPost.media.length}
                        </span>
                      </div>
                      <button className="nav-button right" onClick={goNext}>
                        ❯
                      </button>
                    </div>
                  )}

                <div className="post-info">
                  <div className="info-row">
                    <div className="info-group">
                      <label>Uploaded By</label>
                      <div className="info-field">
                        {selectedPost.uploadedBy}
                      </div>
                    </div>
                    <div className="info-group">
                      <label>Employee ID</label>
                      <div className="info-field">
                        {selectedPost.employeeId}
                      </div>
                    </div>
                  </div>

                  <div className="info-row">
                    <div className="info-group">
                      <label>Post Type</label>
                      <div className="info-field">{selectedPost.postType}</div>
                    </div>
                    <div className="info-group">
                      <label>Posted on</label>
                      <div className="info-field">{selectedPost.dateTime}</div>
                    </div>
                  </div>

                  <div className="info-group full-width">
                    <label>Post Content</label>
                    <textarea
                      className="info-textarea"
                      value={selectedPost.description}
                      readOnly
                    />
                  </div>
                </div>

                {showRemarkBox && (
                  <textarea
                    placeholder="Enter remarks if rejecting"
                    value={rejectRemark}
                    onChange={(e) => setRejectRemark(e.target.value)}
                    className="remark-box"
                  />
                )}

                <div className="modal-actions">
                  <button className="reject-btn" onClick={handleDeleteClick}>
                    Delete
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Delete Confirmation Modal */}
          {showDeleteConfirmation && (
            <div className="modal-overlay">
              <div
                className="modal-content"
                style={{
                  maxWidth: "400px",
                  marginTop: "50px",
                  textAlign: "center",
                }}
              >
                <h5 className="modal-heading">Confirm Deletion</h5>
                <p>Are you sure you want to delete this post?</p>
                <div className="modal-actions">
                  <button
                    className="approve-btn "
                    onClick={handleDeleteConfirm}
                    style={{ marginRight: "10px" }}
                  >
                    Yes
                  </button>
                  <button className="reject-btn" onClick={handleDeleteCancel}>
                    No
                  </button>
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default DeletePosts;
